import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20Korean%20manhwa%20vibe%2C%20soft%20warm%20coral%20and%20cream%20gradient%20background%2C%20elegant%20flowing%20brush%20strokes%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20artistic%20composition%2C%20gentle%20color%20transitions%2C%20no%20text%20or%20characters%2C%20clean%20and%20sophisticated%20atmosphere%2C%20high%20quality%20digital%20art%20with%20painterly%20feel&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
        alt="韩国漫画网 - 高清韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
            <div className="flex-1 max-w-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex -space-x-2">
                  <div className="w-9 h-9 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Asian%20young%20woman%20simple%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20neutral%20background%2C%20minimalist%20headshot%2C%20high%20quality&width=80&height=80&seq=avatar-sm-01&orientation=squarish"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Asian%20young%20man%20simple%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20neutral%20background%2C%20minimalist%20headshot%2C%20high%20quality&width=80&height=80&seq=avatar-sm-02&orientation=squarish"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Asian%20young%20female%20simple%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20neutral%20background%2C%20minimalist%20headshot%2C%20high%20quality&width=80&height=80&seq=avatar-sm-03&orientation=squarish"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <span className="text-sm text-white/80 font-medium">
                  超过 50万+ 漫迷的阅读选择
                </span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
                <span className="font-light">发现</span>高清韩漫
                <br />
                <span className="font-light">开启</span>精彩阅读之旅
              </h1>

              <Link
                to="/category/action"
                className="inline-flex items-center gap-2 bg-white text-foreground-900 font-medium px-6 py-3 rounded-full text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="lg:max-w-sm">
              <p className="text-white/70 text-sm md:text-base leading-relaxed">
                韩国漫画网汇聚海量优质韩漫资源，高清画质、流畅加载，为您打造极致的在线阅读体验。每日更新，精彩不停。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}